<template>
    <div class="feedback__items">
        <div class="feedback__item feedback__item_comment feedback__item_comment-answer feedback__c-answer">
            <img :src="userAvatar" alt="#" class="avatar feedback__i-avatar">
            <label class="field">
                <span class="field__caption">Отзыв</span>
                <el-input
                        v-model="comment.description"
                        required>
                </el-input>
            </label>
            <button class="r-button feedback__c-button" @click="postComment()">
                <span class="screen-reader">Ответить</span>
            </button>
        </div>
    </div>
</template>

<script>
    import {mapState, mapGetters, mapMutations, mapActions} from 'vuex';

    export default {
        name: "FormResponse",
        props: ["parentId"],
        computed: {
            ...mapState([
                'userAvatar',
                'comment',
            ]),
        },
        mounted() {
            this.comment.parentId = this.parentId;
        },
        methods: {
            ...mapActions([
                'postComment',
            ]),
        }
    }
</script>
